import { createContext, useContext, useMemo } from "react";

import type { Me } from "@/api/types";

import { type Session, toSession } from "./session";

const SessionContext = createContext<Session | null>(null);

/**
 * Lo pone `RequireSession` cuando hay sesión. Así, al cerrarla (logout o 401),
 * las pantallas no se vuelven a pintar con `me = null`: la guarda redirige antes.
 */
export const SessionProvider = ({
  me,
  children,
}: {
  me: Me;
  children: React.ReactNode;
}) => {
  const session = useMemo(() => toSession(me), [me]);
  return (
    <SessionContext.Provider value={session}>
      {children}
    </SessionContext.Provider>
  );
};

/** La sesión actual, dentro de `<RequireSession>`. */
export const useSession = (): Session => {
  const session = useContext(SessionContext);
  if (!session) {
    throw new Error("useSession fuera de <RequireSession>");
  }
  return session;
};
